import { ref as i } from "vue";
const e = i(!1);
function t() {
  function r(o) {
    e.value = o;
  }
  return {
    setShowPriceLegal: r,
    showPriceLegal: e
  };
}
export {
  t as useShowPriceDisclaimer
};
